import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';

console.log("Anivista: main.tsx loading modules...");
console.log("Anivista: React & ReactDOM/client successfully resolved");
console.log("Anivista: App component imported, attempting mount...");

// Service Worker Registration pour PWA
// Important: en mode dev (ex: Vite + tunnel Cloudflare), le SW peut servir une version cachée de index.html
// et provoquer des erreurs difficiles à diagnostiquer (double React / invalid hook call).
const enableServiceWorker = (import.meta as any).env?.VITE_ENABLE_SW === 'true';

if (import.meta.env.PROD && enableServiceWorker) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('Anivista: Service Worker registered with scope:', registration.scope);
          
          // Vérifier les mises à jour du service worker
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // Nouveau service worker disponible, proposer la mise à jour
                  if (confirm('Une nouvelle version de Anivista est disponible. Voulez-vous mettre à jour ?')) {
                    newWorker.postMessage({ type: 'SKIP_WAITING' });
                    window.location.reload();
                  }
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error('Anivista: Service Worker registration failed:', error);
        });
    });
  } else {
    console.log('Anivista: Service Worker not supported');
  }
}

// PWA Install Prompt
let deferredPrompt: any = null;

if (import.meta.env.PROD) {
  window.addEventListener('beforeinstallprompt', (e) => {
    console.log('Anivista: Install prompt detected');
    e.preventDefault();
    deferredPrompt = e;
    
    // Stocker l'événement pour l'utiliser dans React
    (window as any).pwaDeferredPrompt = deferredPrompt;
    
    // Déclencher un événement personnalisé pour React
    window.dispatchEvent(new CustomEvent('pwa-installable'));
  });

  // Écouter l'installation de l'app
  window.addEventListener('appinstalled', () => {
    console.log('Anivista: App was installed');
    deferredPrompt = null;
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error("Anivista: CRITICAL - Root element not found in DOM!");
} else {
  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log("Anivista: Initial render call executed");
  } catch (err) {
    console.error("Anivista: Render exception:", err);
  }
}
